export const accordionData = [
  {
    title: "BJP (Bharatiya Janata Party)",
    bgImg: "/uploads/2025/10/20.webp",
    personImg: "/uploads/1/mainbjp.png",
    name: "P.V.N. Madhav",
    text: "Focuses on national development, economic reforms, and welfare schemes.",
    link: "/about_bjp"
  },
  {
    title: "TDP (Telugu Desam Party)",
    bgImg: "/uploads/2025/10/12.webp",
    personImg: "/uploads/2025/10/M-SOCIAL_MEDIA_9949836648-removebg-preview.webp",
    name: "N. Chandrababu Naidu ",
    text: "Emphasizes infrastructure growth, job creation, digital initiatives, affordable housing, and financial support for small businesses and women entrepreneurs.",
    link: "/about_tdp"
  },
  {
    title: "JSP (Janasena Party)",
    bgImg: "/uploads/2025/10/6.webp",
    personImg: "/uploads/2025/10/Pasumpon_Thevar_Photo_Hd_Images-removebg-preview-1.webp",
    name: "Pawan Kalyan ",
    text: "Focuses on social welfare programs, education reforms, and improving healthcare facilities.",
    link: "/about_jsp"
  },
    {
    title: "YSRCP (Yuvajana Sramika Rythu Congress Party)",
    subtitle: "2025",
    bgImg: "/uploads/2025/10/10.webp",
    personImg: "/uploads/2025/10/YSJAGAN_HD-removebg-preview-1.webp",
    name: "YS Jagan Mohan Reddy ",
    text: "Focused on welfare and development in Andhra Pradesh: includes healthcare, education support, farmer assistance, pensions for the elderly, and financial schemes for women and students.",
    link: "/about_ysrcp"
  },
  {
    title: "Indian National Congress (INC)",
    bgImg: "/uploads/2025/10/16.webp",
    personImg: "/uploads/1/congress.png",
    name: "Y S sharmila",
    text: "Advocates for equality, education, healthcare, and employment.",
    link: "/about_congress"
  },
  {
    title: "Communist Party of India",
    bgImg: "/uploads/2025/10/8.webp",
    personImg: "/uploads/1/cpim.png",
    name: "V.Srinivasa Rao",
    text: "Works to protect the rights of labourers, peasants, women, and students.",
    link: "/about_cpmi"
  }

];
